// Import CSS styles
import './login.css'

import { useState } from 'react'

import { Button, Input, Spinner } from '../../Components'
import noraLogoSvg from '../../Components/Common/images/nora-logo.svg'
import siapDark from '../../Components/Common/images/siap_dark.png'
import siapLight from '../../Components/Common/images/siap_light.png'
import { useAuth } from '../../Provider/AuthProvider'
import cisalpinaLogo from '../../Resources/LogoCisalpina.png'
import { cap } from '../../State'
import { translations } from '../../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

function Login() {
  const { onLogin } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [waiting, setWaiting] = useState(false)
  const [darkMode] = cap.darkMode.useState()

  const onClickLogin = async () => {
    setWaiting(true)
    await onLogin({ username, password })
    setWaiting(false)
  }

  // Determine which logo to show based on host
  const isCisanora =
    window.location.host === 'cisanora.siapcn.it' ||
    window.location.host === 'cisanoratest.siapcn.it' ||
    window.location.host === 'cisanora.siap.cloud' ||
    window.location.host === 'cisanoratest.siap.cloud'

  return (
    <div className="nlogin-v2">
      <div className="nlogin-v2__bg" />

      <div className="nlogin-v2__card">
        <div className="nlogin-v2__logo">
          {isCisanora ? (
            <img src={cisalpinaLogo} alt="Logo" className="nlogin-v2__logo-img" />
          ) : darkMode ? (
            <img src={noraLogoSvg} alt="NORA" className="nlogin-v2__nora-logo" />
          ) : (
            <div
              className="nlogin-v2__nora-logo nlogin-v2__nora-logo--gradient"
              role="img"
              aria-label="NORA"
              style={{ WebkitMaskImage: `url(${noraLogoSvg})`, maskImage: `url(${noraLogoSvg})` }}
            />
          )}
        </div>

        <h2 className="nlogin-v2__title">{t.loginTitle}</h2>

        <div className="nlogin-v2__field">
          <Input
            value={username}
            placeholder={t.admUsername}
            onChange={({ username }) => setUsername(username)}
            id="username"
          />
        </div>

        <div className="nlogin-v2__field">
          <Input
            password
            placeholder={t.admPassword}
            id="password"
            value={password}
            onChange={setPassword}
            onEnter={onClickLogin}
          />
        </div>

        <div className="nlogin-v2__actions">
          {waiting ? (
            <Spinner />
          ) : (
            <Button
              label={t.loginButton}
              icon="cloud-up"
              onClick={onClickLogin}
              className="nbtn nbtn--primary nlogin-v2__submit"
            />
          )}
        </div>

        <div className="nlogin-v2__powered">
          <span>{t.poweredBy}</span>
          <img
            src={darkMode ? siapLight : siapDark}
            alt="SIAP"
            className="nlogin-v2__powered-logo"
          />
        </div>
      </div>
    </div>
  )
}

export default Login
